// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React from 'react'
import { Dropdown, Button, Menu } from 'antd'
import classnames from 'classnames'
import { DownOutlined } from '@ant-design/icons'
import { DeviceStatus } from 'constants/device'

export interface IHealthCheckProps {
  onChange: (value: DeviceStatus | -1) => void
  value: DeviceStatus
}

export class HealthCheck extends React.Component<IHealthCheckProps> {
  private handleSelect = ({ item, key }) => {
    const { onChange } = this.props
    onChange(Number(key))
  }

  render () {
    const { value } = this.props
    const actived = value !== -1
    let text
    switch (value) {
      case -1:
        text = 'Health track'
        break
      case DeviceStatus.Healthy:
        text = 'Healthy'
        break
      case DeviceStatus.Issue:
        text = 'Issue'
        break
      case DeviceStatus.Damaged:
        text = 'Damaged'
        break
      default:
        break
    }
    const menu = (
      <Menu onClick={this.handleSelect} selectedKeys={[value.toString()]}>
        <Menu.Item key={DeviceStatus.Healthy.toString()}>Healthy</Menu.Item>
        <Menu.Item key={DeviceStatus.Issue.toString()}>Issue</Menu.Item>
        {/* <Menu.Item key={DeviceStatus.Damaged.toString()}>Damaged</Menu.Item> */}
        <Menu.Item key={'-1'}>All</Menu.Item>
      </Menu>
    )
    const classname = classnames('camera-finder-dropdown-button', {
      actived: actived
    })
    return (
      <Dropdown overlay={menu}>
        <Button className={classname} size='small'>
          {text} <DownOutlined />
        </Button>
      </Dropdown>
    )
  }
}
